// @flow

import styled, { css } from 'styled-components';

const styles = css`
  background-image: url(${props => props.image});
  background-position: center;
  background-repeat: no-repeat;
  background-size: ${props => props.size || 'contain'};
  display: block;
  height: ${props => props.height};
  width: ${props => props.width};
  a {
    display: block;
    height: ${props => props.height};
    width: ${props => props.width};
  }
`;

const ContainedImage = styled.div`
  ${styles}
  text-indent: -9999px;
`;

export {
  ContainedImage,
  styles
};
export default ContainedImage;



// WEBPACK FOOTER //
// ./src/components/ContainedImage.js